/**
 * The dashboard's "Admin" link, with how many debug reports are waiting
 * (api/debug-reports.ts) — the one place an owner passes on every visit, so
 * a report someone sent from a broken board is seen without being looked for.
 * One fetch per mount, no polling: the count is a nudge, not an inbox.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { fetchDebugReports } from "../../core/api.js";

export function AdminLink() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    fetchDebugReports(50)
      .then((response) => {
        if (!cancelled) setCount(response.items.length);
      })
      .catch(() => {
        // The link works without the count.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Link to="/admin" className="btn btn-ghost">
      Admin
      {count > 0 && (
        <span
          className="admin-link-count"
          title={`${count} debug report${count === 1 ? "" : "s"} waiting`}
        >
          {count >= 50 ? "50+" : count}
        </span>
      )}
    </Link>
  );
}
